import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=f2172bd4"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"
import style0 from "./catalog.vue?vue&type=style&index=0&id=f2172bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/app/components/ui/button/c-btn.vue').default,NoContentBlock: require('/app/components/global/no-content-block.vue').default})
